<template>
    <!-- ============================================================== -->
    <!-- Language, només apareix si hi ha més d'un idioma disponible a main.js -->
    <!-- ============================================================== -->
    <li v-if="Object.values($i18n.availableLocales).length > 1" class="nav-item dropdown" id="idioma">
        <el-dropdown trigger="click" class="nav-link dropdown-toggle">
            <a class="el-dropdown-link">
                <span class="sr-only">{{ $t("Selecciona l'idioma") }}</span>
                <i class="mdi mdi-earth"></i>
            </a>
            <template #dropdown>
                <el-dropdown-menu class="language-selector">
                    <el-dropdown-item v-for="id in $i18n.availableLocales" :key="id" @click="canviIdioma(id)">
                        <a role="menuitem" :class="{selected: $i18n.locale===id}" href="#">{{ getTextLanguage(id) }}</a>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </template>
        </el-dropdown>
    </li>
</template>

<script>
/**
 * Component intern que mostra els idiomes disponibles a l'aplicació.
 *
 * Apareix destacat el que està seleccionat actualment.
 *
 * Clica en un idioma per seleccionar-lo.
 */
    export default {
        name: 'CustomIdioma',
        methods: {
            canviIdioma (idioma) {
                this.setIdioma(idioma)
            },
            getTextLanguage(id) {
                switch (id) {
                    case 'ca':  return 'Català';
                    case 'es':  return 'Español';
                    case 'en':  return 'English';
                    default:    return id;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .language-selector {
        .selected {
            font-weight: 600;
        }
    }
    .el-dropdown-menu__item:hover {
        background-color: #007bc0;
        a {
            color: #fff;
        }
    }
</style>
